<template>
  <div
    class="sticky top-0 z-[40] flex w-full items-center gap-x-[2px] border py-4 pl-6 pr-[22px] text-[13px] font-medium leading-5 md:px-12"
    :class="[
      {
        'border-gpx_red-300 bg-gpx_red-300 text-gpx_red-100':
          variant === NOTIFICATION_VARIANT.error,
        'border-gpx_yellow-280 bg-gpx_yellow-280 text-gpx_yellow-100':
          variant === NOTIFICATION_VARIANT.warning,
        'border-gpx_green-300 bg-gpx_green-300 text-gpx_green-100':
          variant === NOTIFICATION_VARIANT.success,
        'border-gpx_gray-800 bg-white text-gpx_black-500':
          variant === NOTIFICATION_VARIANT.default,
      },
    ]"
  >
    <component v-if="Boolean(icon)" :is="icon" class="mr-[9px] h-6 w-6" />
    <slot />
  </div>
</template>

<script>
import { NOTIFICATION_VARIANT } from './utils';

export default {
  props: {
    icon: String,
    variant: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      NOTIFICATION_VARIANT: NOTIFICATION_VARIANT,
    };
  },
};
</script>
